<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('school.payment.setup.feeGroup.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('school.payment.setup.feeGroup.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div>
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'fee-group-create' })"
              >{{ $t('add_new') }}</ts-button
            >
          </div>
          <div style="width: 25%">
            <div class="d-flex justify-content-between">
              <select class="form-control mr-2">
                <option value>{{ $t('feegroup.branch') }}</option>
              </select>
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 100%"
              />
            </div>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner :loading="exporting">
          <Table
            row-key="index"
            :columns="columns"
            :data="groupResources"
            :span-method="handleSpan"
            size="small"
            :loading="loading"
            highlight-row
            stripe
          >
            <template slot-scope="{ row }" slot="branch_name_en">
              {{ row.branch ? row.branch.branch_name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="action">
              <a
                href="#"
                title="Edit"
                class="mr-2 text-primary"
                @click.prevent="edit(row)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                title="Delete"
                class="text-danger"
                @click.prevent="destroy(row)"
                :disabled="row._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </template>
          </Table>
        </ts-loading-banner>
        <div class="d-flex justify-content-between align-items-center p-15">
          <ts-total-list v-model="pagination" />
          <ts-pagination
            v-model="pagination"
            @navigate="fetchData"
          ></ts-pagination>
        </div>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import iTable from '@/store/i-table-helper'
export default {
  name: 'feeGroup',
  data () {
    return {
      loading: false,
      exporting: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('feeGroup', ['resources', 'pagination']),
    groupResources () {
      return iTable.rowGroup(this.resources, 'payment_term')
    },
    search: {
      get () {
        return this.$store.state.feeGroup.search
      },
      set (newValue) {
        this.$store.commit('feeGroup/SET_SEARCH', newValue)
        this.$store.commit('feeGroup/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          key: 'column_name',
          tree: true,
          maxWidth: 15,
          className: 'text-primary bold'
        },
        {
          title: this.$t('school.payment.setup.feeGroup.branch'),
          minWidth: 140,
          slot: 'branch_name_en'
        },
        {
          title: this.$t('school.payment.setup.feeGroup.groupName'),
          minWidth: 160,
          key: 'fee_group_name'
        },
        {
          title: this.$t('school.payment.setup.feeGroup.amount'),
          align: 'center',
          key: 'fee_amount',
          minWidth: 120
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 150
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('feeGroup/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit (record) {
      this.$store.commit('feeGroup/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'fee-group-edit',
        params: { id: record.fee_group_id }
      })
    },
    async destroy (record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('feeGroup/destroy', record.fee_group_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    handleSpan ({ row, column, rowIndex, columnIndex }) {
      return iTable.handleSpan(row, columnIndex, this.columns)
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
<style lang="css">
.bold {
  font-weight: bold;
}
</style>
